import {Component} from "@angular/core";

@Component({
  selector: 'app-dummy-component',
  template: '',
  styles: ['']
})
export class DummyComponent {
}
